import { LanguageTag } from '@vista-digital/ocapi-types/v1';
import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../../utils/validators/string';
export const defaultLanguage = {
    languageTag: LanguageTag.English,
    label: 'English',
    iconName: 'united-kingdom-flag',
    isDefault: true
};
export const languageValidator = Validator.object({
    iconName: nonEmptyStringValidator,
    languageTag: Validator.oneOf(Object.values(LanguageTag)),
    label: nonEmptyStringValidator,
    isDefault: Validator.boolean()
});
